export default function UserFavorites() {
    return (
        <div>
            <h1>User Favorites</h1>
            <h6>user\Favorites.jsx</h6>
        </div>
    )
}